<!-- Title -->
<h1 mat-dialog-title>
  {{ 'addcluster' | translate }}
</h1>

<!-- Content -->
<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="column">

    <mat-form-field appearance="standard">
      <mat-label>{{ 'name' | translate }}</mat-label>
      <input matInput formControlName="name">
      <mat-hint>{{ 'clusterHintName' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('name').hasError('required')">{{ 'fieldrequired' | translate }}</mat-error>
      <mat-error *ngIf="form.get('name').hasError('unique')">{{ 'clusterErrorNameNotUnique' | translate }}</mat-error>
    </mat-form-field>
    
    <mat-form-field appearance="standard">
      <mat-label>{{ 'code' | translate }}</mat-label>
      <input matInput formControlName="shortCode" (keyup)="form.patchValue({ shortCode: $event.target.value.toUpperCase() })">
      <mat-hint>{{ 'clusterHintShortCode' | translate }}</mat-hint>
      <mat-error *ngIf="form.get('shortCode').hasError('required')">{{ 'fieldrequired' | translate }}</mat-error>
      <mat-error *ngIf="form.get('shortCode').hasError('maxlength')">{{ 'clusterErrorShortCodeMax5' | translate }}</mat-error>
      <mat-error *ngIf="form.get('shortCode').hasError('unique')">{{ 'clusterErrorShortCodeNotUnique' | translate }}</mat-error>
    </mat-form-field>

  </form>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">
  <button mat-button tabindex="-1" (click)="dialogRef.close()">
    {{ 'cancel' | translate }}
  </button>
  <button mat-flat-button (click)="submit()" tabindex="-1" [color]="'primary'" [disabled]="form.invalid">
    {{ 'add' | translate }}
  </button>
</div>
